import script from "./PageBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBanner.vue?vue&type=script&setup=true&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=5b806b4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b806b4e"]])

export default __exports__